import { Component, Input } from '@angular/core';
import { Atto } from '../../../models/atto';

@Component({
    selector: '[atto_entity_view]',
  templateUrl: 'atto-entity-view.component.html',
})

export class AttoEntityViewComponent {
  @Input()
  element: Atto;
}
